/*
 * BeStable - Personalisierungsdialog (Zepto) absichern. Audit 09.10.2026, Nr. 9, 22, 23 (Nutzerfreigabe 09.10.).
 * Wird NUR auf Personalisierungs-Produktseiten geladen (layout/theme.liquid, gleiche Bedingung wie der B2-Fix).
 *
 * Nr. 9  Klaviyo-Popups pausieren, solange der Dialog offen ist (gleiche Selektoren wie die Warenkorb-Pause in
 *        mini-cart.liquid). Das Popup bleibt im DOM und erscheint nach dem Schliessen des Dialogs wieder.
 * Nr. 23 Escape schliesst den Dialog (wie Zeptos X, Funktion pplr_w_h). Nicht waehrend des Zuschneidens
 *        (Zuschnitt-Ansicht = Klasse pplr-crop-mode am Dialog) und nicht im Flaggen-Suchfeld.
 * Nr. 22 Upload-Meldungen in der Shop-Sprache:
 *        - Zeptos englisches alert "Invalid file type!" (PDF, TXT ...) wird uebersetzt (auch auf Deutsch).
 *        - Zeptos deutscher Mindestgroessen-Hinweis ("Fehlgeschlagen bitte Bild erneut hochladen 200px 200px")
 *          wird in Nicht-DE-Sprachen uebersetzt.
 *        - Bleibt nach der Fotoauswahl die Zuschnitt-Ansicht leer, weil der Browser das Bild nicht lesen kann
 *          (TIFF, beschaedigte Datei: Bild geladen, aber 0 px breit, mindestens 5 s lang), erscheint ein Hinweis.
 * Kosmetik (Nutzerwunsch 10./11.10.2026, Freigabe "nur Handy"): Im Handy-Layout ist der Kasten unter den Fotos nur
 *        so hoch wie sein Inhalt; "In den Warenkorb" steht mit etwas Abstand darunter und so breit wie der Kasten,
 *        das X bleibt unten rechts. Nicht in der Zuschnitt-Ansicht, Computer-Layout unveraendert. Details bei kasten().
 *        Seit 15.10. (Freigabe "Wie im Bild") auch Sleeves: Produktname + Preis im Dialog ausgeblendet, Flaggenliste
 *        friert die Aufteilung ein und scrollt beim Oeffnen in Sicht.
 *        22.10.: Sleeves-Kasten nicht mehr kuerzen; X absolut statt fixed; auf kleinen Handys Bild kleiner (nur Anzeige),
 *        damit das Flaggenfeld ganz sichtbar ist; nach dem Zuklappen der Flaggenliste zurueck nach oben scrollen.
 *        22.10. spaet: Bezug fuer "Bild kleiner" ist das unterste Feld (Feld-Reihenfolge in Zepto frei, Flagge vorn).
 * Stand der Zepto-Struktur: Lese-Test 09.10. (probe-zepto.js). Aendert Zepto sein Markup, greifen die Teile still nicht.
 */
(function () {
  "use strict";
  if (window.__bsPersoGuard) return;
  window.__bsPersoGuard = true;

  var LOC = ((window.Shopify && window.Shopify.locale) || "de").slice(0, 2);
  var T = {
    invalid: {
      de: "Dieser Dateityp wird nicht unterstützt. Bitte wähle ein Foto im Format JPG, PNG, WEBP oder HEIC.",
      en: "This file type isn’t supported. Please choose a photo in JPG, PNG, WEBP or HEIC format.",
      es: "Este tipo de archivo no es compatible. Elige una foto en formato JPG, PNG, WEBP o HEIC.",
      fr: "Ce type de fichier n’est pas pris en charge. Choisis une photo au format JPG, PNG, WEBP ou HEIC.",
      it: "Questo tipo di file non è supportato. Scegli una foto in formato JPG, PNG, WEBP o HEIC.",
      nl: "Dit bestandstype wordt niet ondersteund. Kies een foto in JPG-, PNG-, WEBP- of HEIC-formaat.",
      pl: "Ten typ pliku nie jest obsługiwany. Wybierz zdjęcie w formacie JPG, PNG, WEBP lub HEIC.",
      sv: "Den här filtypen stöds inte. Välj ett foto i formatet JPG, PNG, WEBP eller HEIC."
    },
    small: {
      en: "Upload failed – please upload the photo again (min. {w} × {h} px).",
      es: "No se ha podido subir la foto. Vuelve a subirla (mín. {w} × {h} px).",
      fr: "Échec de l’envoi – merci de renvoyer la photo (min. {w} × {h} px).",
      it: "Caricamento non riuscito: carica di nuovo la foto (min. {w} × {h} px).",
      nl: "Uploaden mislukt – upload de foto opnieuw (min. {w} × {h} px).",
      pl: "Przesyłanie nie powiodło się – prześlij zdjęcie ponownie (min. {w} × {h} px).",
      sv: "Uppladdningen misslyckades – ladda upp fotot igen (minst {w} × {h} px)."
    },
    stuck: {
      de: "Dieses Foto konnte nicht geladen werden. Bitte lösche es über den Papierkorb und wähle ein anderes Foto (JPG oder PNG).",
      en: "This photo couldn’t be loaded. Please delete it with the bin icon and choose another photo (JPG or PNG).",
      es: "No se ha podido cargar esta foto. Elimínala con el icono de la papelera y elige otra foto (JPG o PNG).",
      fr: "Cette photo n’a pas pu être chargée. Supprime-la avec l’icône de corbeille et choisis une autre photo (JPG ou PNG).",
      it: "Non è stato possibile caricare questa foto. Eliminala con l’icona del cestino e scegli un’altra foto (JPG o PNG).",
      nl: "Deze foto kon niet worden geladen. Verwijder hem met het prullenbakicoon en kies een andere foto (JPG of PNG).",
      pl: "Nie udało się wczytać tego zdjęcia. Usuń je ikoną kosza i wybierz inne zdjęcie (JPG lub PNG).",
      sv: "Det här fotot kunde inte laddas. Ta bort det med papperskorgsikonen och välj ett annat foto (JPG eller PNG)."
    }
  };
  function text(k) { return (T[k] && (T[k][LOC] || T[k].de)) || ""; }

  function sichtbar(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!(r.width > 0 && r.height > 0)) return false;
    var cs = getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden";
  }
  function offenerDialog() {
    var ps = document.querySelectorAll(".pplr-popup");
    for (var i = 0; i < ps.length; i++) { if (sichtbar(ps[i])) return ps[i]; }
    return null;
  }

  /* ---------- Stil ---------- */
  var st = document.createElement("style");
  st.id = "bs-perso-guard-style";
  st.textContent =
    "html.bs-pplr-open body > div > [class*=\"kl-private-reset-css\"]," +
    "html.bs-pplr-open body > [class*=\"kl-private-reset-css\"]{display:none!important}" +
    "#bs-pplr-hint{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;" +
    "box-sizing:border-box;width:max-content;max-width:min(92vw,520px);padding:12px 16px;border-radius:8px;" +
    "background:#1a1a1a;color:#fff;font-size:14px;line-height:1.45;box-shadow:0 8px 28px rgba(0,0,0,.35);text-align:left}" +
    /* 15.10. (Nutzerwunsch Sleeves): Produktname + Preis oben im Dialog ausblenden - nahm am Handy den Platz der
       Flaggenauswahl weg. Steht nur im Sleeves-Dialog (Schoner/Mini haben keinen, geprueft 15.10.). */
    ".pplr-popup label.pplr_h_title{display:none!important}";
  (document.head || document.documentElement).appendChild(st);

  /* ---------- Nr. 22: Hinweis-Leiste ---------- */
  /* Nur bei echter Aenderung ins DOM schreiben - sonst triggert der MutationObserver unten sich selbst. */
  var hinweis = null;
  function zeigeHinweis(t) {
    if (!hinweis) {
      hinweis = document.createElement("div");
      hinweis.id = "bs-pplr-hint";
      hinweis.setAttribute("role", "alert");
      hinweis.style.display = "none";
      document.body.appendChild(hinweis);
    }
    if (hinweis.textContent !== t) hinweis.textContent = t;
    if (hinweis.style.display !== "") hinweis.style.display = "";
  }
  function versteckeHinweis() { if (hinweis && hinweis.style.display !== "none") hinweis.style.display = "none"; }

  /* Nr. 22a: Zeptos englisches alert uebersetzen */
  var bsAlert = window.alert;
  if (typeof bsAlert === "function") {
    window.alert = function (msg) {
      try { if (typeof msg === "string" && /^\s*invalid file type!?\s*$/i.test(msg)) msg = text("invalid"); } catch (e) {}
      return bsAlert.call(window, msg);
    };
  }

  /* Nr. 22b: Zeptos deutschen Mindestgroessen-Hinweis uebersetzen (nur Nicht-DE) */
  var RX_KLEIN = /^\s*Fehlgeschlagen bitte Bild erneut hochladen\s*(\d+)\s*px\s+(\d+)\s*px\s*$/;
  function uebersetzeMeldungen() {
    if (LOC === "de" || !T.small[LOC]) return;
    var ws = document.querySelectorAll(".pplr-popup .p_m_warning");
    for (var i = 0; i < ws.length; i++) {
      var m = (ws[i].textContent || "").match(RX_KLEIN);
      if (m) ws[i].textContent = T.small[LOC].replace("{w}", m[1]).replace("{h}", m[2]);
    }
  }

  /* Nr. 22c: Foto wird nicht verarbeitet (Zuschnitt-Ansicht ohne Zuschneider, Bild nicht lesbar) */
  function defektesBild(pop) {
    var imgs = pop.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) {
      var s = imgs[i].getAttribute("src") || "";
      if ((s.indexOf("data:image") === 0 || s.indexOf("blob:") === 0) && imgs[i].complete && imgs[i].naturalWidth === 0) {
        return s.length + "|" + s.slice(0, 80);
      }
    }
    return null;
  }
  var wache = null;
  function beobachteUpload() {
    versteckeHinweis();
    if (wache) clearInterval(wache);
    var t0 = Date.now(), sig = null, seit = 0;
    wache = setInterval(function () {
      var pop = offenerDialog();
      if (!pop || Date.now() - t0 > 60000) { clearInterval(wache); wache = null; versteckeHinweis(); return; }
      var zuschnitt = pop.classList.contains("pplr-crop-mode");
      if (!zuschnitt || sichtbar(pop.querySelector(".cropper-container"))) { sig = null; versteckeHinweis(); return; }
      var neu = defektesBild(pop);
      if (!neu) { sig = null; versteckeHinweis(); return; }
      if (neu !== sig) { sig = neu; seit = Date.now(); return; }
      if (Date.now() - seit >= 5000) zeigeHinweis(text("stuck"));
    }, 500);
  }
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(".pplr-popup input[type=file]")) beobachteUpload();
  }, true);

  /* ---------- Kosmetik (Nutzerwunsch 10./11.10.2026, nur Handy): Kasten so hoch wie sein Inhalt ----------
     Zepto setzt beim Oeffnen feste Inline-Hoehen auf .pplr-p-right und .pplr-modal-body (= ganzer freier Platz),
     dadurch stand "In den Warenkorb" am Handy ganz unten. Nur im gestapelten Handy-Layout (Formular = Flex-Spalte)
     (bis 14.10. ohne Zepto-Ausklappliste; seit 15.10. auch Sleeves, Liste s. u.): Hoehe folgt dem Inhalt,
     Zeptos Wert bleibt Obergrenze (laengerer Inhalt scrollt wie bisher im Kasten), der Kasten waechst nicht mehr in
     den freien Platz (flex 0 1 auto; Basis auto, sonst faellt ein Scroll-Kasten auf 0).
     Knopf-Zeile (11.10.): Ist genug Platz, steht "In den Warenkorb" LUFT px unter dem Kasten und so breit wie der
     Kasten; das X bleibt an seinem alten Platz unten rechts (position fixed, gleiche Abstaende wie in Zeptos
     Original-Zeile; kein Vorfahr mit transform, geprueft 11.10.). Ist wenig Platz (z. B. zwei Fotos auf kleinem
     Handy), steht die Zeile wie bei Zepto unten (margin-top auto), X daneben (Knopfbreite seit 15.10. s. u.).
     Zuschnitt-Ansicht und Computer-Layout: Zeptos Werte bleiben bzw. werden wiederhergestellt.
     Jede Zuweisung nur bei echter Aenderung (sonst loest der MutationObserver unten sich selbst aus); Schutz gegen
     Hin und Her mit Zepto: mehr als 20 schreibende Durchlaeufe in 2 s -> fuer diesen Kasten aufgeben, Originalwerte.
     15.10. (Nutzerbefund, Freigabe "Ja, wie Vorschlag"): Zepto behaelt hochgeladene Fotos nach Schliessen und nach
     "In den Warenkorb" -> Kasten hoeher -> bisher Rueckfall auf Zeptos Zeile (schmaler Knopf unten, X daneben).
     Jetzt entscheidet die Inhaltshoehe C (scrollHeight + Rahmen) gegen Zeptos Hoehe H0, nicht der Restplatz
     (stabil, kein Hin und Her): C passt mit 32 px -> wie eingestellt; passt mit weniger -> Abstand schrumpft bis
     12 px; scrollt der Inhalt ohnehin (C > H0) -> Kasten wird gekuerzt (max-height = H0 - 32 - Platz fuer das X),
     Knopf bleibt kastenbreit 32 px darunter, X unten rechts. Nur wenn der Inhalt gerade noch ohne Scrollen passt
     (sehr kleines Handy ohne Fotos), bleibt Zeptos Zeile unten - Knopf aber breit (flex-grow, 12 px zum X),
     damit kein Upload-Feld weggescrollt wird. */
  var LUFT = 32, LUFT_MIN = 12, X_ABST = 8, X_NEBEN = 12, KASTEN_MIN = 160;
  /* 22.10. abends (Nutzerwunsch, Freigabe "setz es bitte um in kleiner"): Sleeves auf kleinen Handys. Steht das
     Flaggenfeld nicht ganz im Kasten (kleines iPhone, SE), wird das Vorschaubild nur so weit kleiner gezeigt, dass das
     Feld mit LUFT_F px Luft hineinpasst (Bild mindestens MIN_BILD px); der Kasten waechst um denselben Betrag, Knopf und
     X bleiben an ihrer Stelle. Nur Anzeige (transform am Bildbereich) - Zeptos Zeichenflaeche und die erzeugte Datei
     bleiben unveraendert (gemessen 22.10.: 1098x2551, byte-gleich). Auf groesseren Handys und am Computer: keine Aenderung.
     Die Rechnung nutzt immer die Lage OHNE Verkleinerung (b.__bsMinus wird herausgerechnet) - so kein Hin und Her.
     22.10. spaet: Bezug ist das UNTERSTE Eingabefeld im Kasten, nicht fest das Flaggenfeld - die Reihenfolge der Felder
     stellt der Nutzer in Zepto ein (Flagge nach vorn). Steht die Flagge zuletzt, ist das unterste Feld die
     Flaggenanzeige: Verhalten exakt wie zuvor. */
  var LUFT_F = 16, MIN_BILD = 140;
  /* Unterkante des untersten sichtbaren Eingabefelds im Kasten, gemessen ab Inhaltsbeginn (scrollTop eingerechnet).
     Nicht mitgezaehlt: alles in der Flaggenliste (Suchfeld, Eintraege) und unsichtbare Felder (Zeptos versteckte Werte). */
  function feldUnten(b) {
    var els = b.querySelectorAll('input[type="text"], input[type="number"], input[type="tel"], textarea, select, .pplr-selecter-selected');
    var rb = b.getBoundingClientRect(), u = 0;
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.closest(".img_thumb_dropdown")) continue;
      if (!e.offsetHeight && !e.offsetWidth) continue;
      var rel = e.getBoundingClientRect().bottom - rb.top + b.scrollTop;
      if (rel > u) u = rel;
    }
    return u;
  }
  var bildStil = null;
  function bildRegel(k, minus) {
    var t = ".pplr-popup .pplr-p-left.bs-bild-klein{transform:scale(" + k + ") !important;" +
      "transform-origin:50% 0 !important;margin-bottom:" + (-minus) + "px !important}";
    if (!bildStil) {
      bildStil = document.createElement("style");
      bildStil.id = "bs-bild-klein-style";
      (document.head || document.documentElement).appendChild(bildStil);
    }
    if (bildStil.textContent !== t) { bildStil.textContent = t; return true; }
    return false;
  }
  /* 22.10. abends: Zepto rechnet bei Groessenwechsel (pplr_modal_correct, u. a. ueber adjust_r_o bei resize und
     orientationchange) die Bildhoehe aus der Hoehe der Knopfzeile INKLUSIVE ihres Abstands nach oben
     (jQuery outerHeight(true)). Unser Abstand (margin-top auto bzw. LUFT, seit 11.10.) liess Bild und Kasten nach
     jedem Groessenwechsel schrumpfen (gemessen 22.10., Kopie ohne diesen Teil: 553 -> 473 -> 553 px Fensterhoehe ergab
     Bild 235 -> 195 px und Kasten 235 -> 191 px, Flaggenfeld wieder abgeschnitten). Darum entfernt dieser Huell-Aufruf
     unseren Abstand kurz vor Zeptos Rechnung; danach stellt kasten() (MutationObserver) alles wieder her.
     Zeptos Funktion ist global (klassisches Skript); fehlt sie oder heisst sie anders, passiert nichts.
     Bewusst NUR im Sleeves-Dialog (Formular mit Flaggenliste): Schoner/Mini bleiben exakt wie bisher (Test 22.10.: ohne
     diese Eingrenzung stand der Mini-Knopf am iPhone 15 anders als heute). */
  function zeptoNeutral() {
    var f = window.pplr_modal_correct;
    if (typeof f !== "function" || f.__bsNeutral) return;
    var w = function () {
      var bs = document.querySelectorAll(".pplr-popup .pplr_ex_button");
      for (var i = 0; i < bs.length; i++) {
        var fo = bs[i].closest("form");
        if (bs[i].style.marginTop && fo && fo.querySelector(".img_thumb_dropdown")) bs[i].style.marginTop = "";
      }
      return f.apply(this, arguments);
    };
    w.__bsNeutral = true;
    try { window.pplr_modal_correct = w; } catch (e) {}
  }
  function kasten() {
    zeptoNeutral();
    var boxes = document.querySelectorAll(".pplr-popup .pplr-p-right");
    for (var i = 0; i < boxes.length; i++) kastenEins(boxes[i]);
  }
  function kastenEins(b) {
    var pop = b.closest(".pplr-popup");
    var body = b.querySelector(".pplr-modal-body");
    var form = b.closest("form");
    var exb = form && form.querySelector(".pplr_ex_button");
    var exi = exb && exb.querySelector(".pplr_ex_inner");
    var atc = exi && exi.querySelector(".p_a_t_c");
    var x = exi && exi.querySelector("a.pplr_close");
    var left = form && form.querySelector(".pplr-p-left");
    var curMinus = b.__bsMinus || 0;
    var n = 0;
    function setz(el, prop, val) { if (el && el.style[prop] !== val) { el.style[prop] = val; n++; } }
    function bildKlein(minus, k) {
      var an = minus > 0 && !!left;
      if (left && left.classList.contains("bs-bild-klein") !== an) { left.classList.toggle("bs-bild-klein", an); n++; }
      if (an && bildRegel(k, minus)) n++;
      b.__bsMinus = an ? minus : 0;
    }
    if (b.style.height && b.style.height !== "auto") b.__bsH = b.style.height;
    if (body && body.style.height && body.style.height !== "auto") body.__bsH = body.style.height;
    var aktiv = !b.__bsAus && !!b.__bsH && !!form && getComputedStyle(form).display === "flex" &&
      !(pop && pop.classList.contains("pplr-crop-mode"));
    /* 15.10. Sleeves: Flaggenliste offen -> Aufteilung einfrieren. Der Kasten wird nicht hoeher als vorher (sonst
       rutschte der Knopf ueber das X bzw. der Knopf sprang hin und her), die Liste wird im Kasten gezeigt: einmal so
       weit scrollen, dass "Laenderflaggen" oben im Kasten steht. Beim Schliessen greift wieder die normale Rechnung. */
    var liste = b.querySelector(".img_thumb_dropdown");
    if (aktiv && b.__bsKompakt && liste && liste.offsetHeight > 0) {
      if (b.__bsLuftAn && b.__bsBoxH) setz(b, "maxHeight", b.__bsBoxH + "px");
      if (!b.__bsListeOffen) { b.__bsListeOffen = true; b.__bsScrollZiel = true; }
      /* Zepto klappt die Liste animiert auf (Hoehe waechst ueber mehrere Bilder) - scrollen geht erst, wenn der Inhalt
         ueberlaeuft: darum bei jedem Durchlauf nachziehen, bis "Laenderflaggen" oben steht oder die Animation fertig ist. */
      if (b.__bsScrollZiel) {
        var lw = liste.closest(".pplr-wrapper") || liste.parentElement;
        var dy = lw.getBoundingClientRect().top - b.getBoundingClientRect().top - 8;
        if (dy > 1) b.scrollTop += dy;
        var rest = lw.getBoundingClientRect().top - b.getBoundingClientRect().top - 8;
        if (rest <= 1 || !/height/.test(liste.getAttribute("style") || "")) b.__bsScrollZiel = false;
      }
    } else if (aktiv) {
      var warOffen = b.__bsListeOffen;
      b.__bsListeOffen = false;
      var hoch = b.__bsH, luft = null, minus = 0, bildH = 0;
      if (exb && exi && atc && x) {
        var H0 = parseFloat(b.__bsH) || 0, exbH = exb.offsetHeight, bedarfX = (exbH + x.offsetHeight) / 2 + X_ABST;
        /* Obergrenze: echter Platz zwischen Kasten-Oberkante und Formular-Unterkante minus Knopfzeile. Zeptos H0 ist
           quer gedreht groesser als der Platz (Test 15.10.: H0 271, Platz 99 -> Knopf und X ueberlappten). */
        var fr0 = form.getBoundingClientRect(), csf = getComputedStyle(form);
        var platz = fr0.bottom - (parseFloat(csf.paddingBottom) || 0) - (parseFloat(csf.borderBottomWidth) || 0) - b.getBoundingClientRect().top - exbH;
        /* 22.10.: Platz ohne unsere Bildverkleinerung (sie schiebt den Kasten um curMinus nach oben) */
        var platzOrig = platz - curMinus;
        if (fr0.height > 0 && platzOrig < H0) H0 = Math.max(0, Math.floor(platzOrig));
        var csb = getComputedStyle(b), C = b.scrollHeight + (parseFloat(csb.borderTopWidth) || 0) + (parseFloat(csb.borderBottomWidth) || 0);
        if (H0 > 0 && exbH > 0) {
          if (C <= H0 - LUFT - bedarfX) luft = LUFT;
          else if (C <= H0 - LUFT_MIN - bedarfX) luft = Math.floor(H0 - bedarfX - C);
          /* 22.10. (Nutzerbefund iPhone FR, Freigabe "Kasten nicht kuerzen"): NICHT bei Sleeves (Kasten mit Flaggenliste).
             Gekuerzt (174 statt 272 px) lag das Flaggenfeld unsichtbar im Scrollbereich. Sleeves bekommen Zeptos
             volle Kastenhoehe, die Knopfzeile steht wie bei Zepto unten (X daneben). */
          else if (C > H0 && H0 - LUFT - bedarfX >= KASTEN_MIN && !liste) { luft = LUFT; hoch = Math.floor(H0 - LUFT - bedarfX) + "px"; }
        }
        /* 22.10. abends: Sleeves - Bild kleiner, wenn das unterste Feld sonst nicht ganz im Kasten steht (s. o. bei LUFT_F) */
        var rl0 = left && left.getBoundingClientRect(), rb0 = b.getBoundingClientRect();
        var gestapelt = !!rl0 && rb0.left < rl0.right - 1 && rl0.left < rb0.right - 1;   /* Bild UEBER dem Kasten, nicht daneben */
        /* nur Hochformat: quer (Handy gedreht) bleibt alles wie bisher - dort passt der Dialog ohnehin nicht ganz (Test 22.10.) */
        if (liste && left && H0 > 0 && gestapelt && innerHeight > innerWidth) {
          var untRel = feldUnten(b);
          if (untRel > 0) {
            var noetig = Math.ceil(untRel + LUFT_F - H0);
            bildH = left.offsetHeight;
            if (noetig > 0 && bildH > MIN_BILD) minus = Math.min(noetig, Math.floor(bildH - MIN_BILD));
            if (minus > 0) hoch = Math.floor(H0 + minus) + "px";
          }
        }
      }
      setz(b, "maxHeight", hoch);
      setz(b, "height", "auto");
      if (b.style.flexGrow !== "0" || b.style.flexBasis !== "auto") { b.style.flex = "0 1 auto"; n++; }
      if (body && body.__bsH) setz(body, "height", "auto");
      if (exb && exi && atc) {
        setz(exb, "marginTop", luft !== null ? luft + "px" : "auto");
        if (luft !== null) {
          /* 22.10. (Nutzerbefund: X lag ueber dem Nummernfeld, Freigabe "unten lassen, nur reparieren"): gleiche Stelle wie
             bisher, aber position absolute zum Dialog statt fixed zum Bildschirm. fixed rechnete mit innerHeight; aendert
             Safari die Fensterhoehe (Tastatur, Adressleiste), stand das X bis zur naechsten Neuberechnung falsch. */
          var fr = form.getBoundingClientRect();
          var xUnten = fr.bottom - (parseFloat(getComputedStyle(exb).paddingBottom) || 0) - (exi.offsetHeight - x.offsetHeight) / 2;
          setz(x, "position", "absolute");
          var op = x.offsetParent || document.documentElement, orr = op.getBoundingClientRect(), cso = getComputedStyle(op);
          setz(x, "right", Math.round(orr.right - (parseFloat(cso.borderRightWidth) || 0) - fr.right) + "px");
          setz(x, "bottom", Math.round(orr.bottom - (parseFloat(cso.borderBottomWidth) || 0) - xUnten) + "px");
          setz(atc, "flexGrow", "1");
          setz(atc, "marginRight", "");
        } else {
          if (x) { setz(x, "position", ""); setz(x, "right", ""); setz(x, "bottom", ""); }
          setz(atc, "flexGrow", "1");
          setz(atc, "marginRight", x ? X_NEBEN + "px" : "");
        }
      }
      bildKlein(minus, bildH > 0 ? Math.round((bildH - minus) / bildH * 10000) / 10000 : 1);
      /* 22.10. abends: Flaggenliste wurde gerade zugeklappt (Land gewaehlt oder daneben getippt) -> Kasten wieder nach
         oben scrollen (15.10. scrollte beim Oeffnen nach unten und blieb dort); nur so weit unten lassen, wie noetig ist,
         damit das Flaggenfeld ganz sichtbar bleibt. */
      if (warOffen && liste) {
        var fw2 = liste.closest(".pplr-wrapper"), fs2 = fw2 && fw2.querySelector(".pplr-selecter-selected"), ziel = 0;
        if (fs2) {
          var rel2 = fs2.getBoundingClientRect().bottom - b.getBoundingClientRect().top + b.scrollTop;
          ziel = Math.max(0, Math.ceil(rel2 + LUFT_F - b.clientHeight));
        }
        if (Math.abs(b.scrollTop - ziel) > 1) b.scrollTop = ziel;
      }
      b.__bsKompakt = true;
      b.__bsLuftAn = luft !== null;
      b.__bsBoxH = b.offsetHeight;
    } else if (b.__bsKompakt) {
      b.__bsListeOffen = false;
      if (b.__bsH) setz(b, "height", b.__bsH);
      setz(b, "maxHeight", "");
      if (b.style.flexGrow || b.style.flexBasis) { b.style.flex = ""; n++; }
      if (body && body.__bsH) setz(body, "height", body.__bsH);
      if (exb) setz(exb, "marginTop", "");
      if (x) { setz(x, "position", ""); setz(x, "right", ""); setz(x, "bottom", ""); }
      if (atc) { setz(atc, "flexGrow", ""); setz(atc, "marginRight", ""); }
      bildKlein(0, 1);
      b.__bsKompakt = false;
    } else if (curMinus || (left && left.classList.contains("bs-bild-klein"))) {
      bildKlein(0, 1);
    }
    if (n) {
      var jetzt = Date.now();
      if (!b.__bsT || jetzt - b.__bsT > 2000) { b.__bsT = jetzt; b.__bsN = 0; }
      b.__bsN++;
      if (b.__bsN > 20 && !b.__bsAus) { b.__bsAus = true; kastenEins(b); }
    }
  }
  function imDialog(recs) {
    for (var i = 0; i < recs.length; i++) {
      var t = recs[i].target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && t.closest && t.closest(".pplr-popup")) return true;
    }
    return false;
  }

  /* ---------- Nr. 9: Klaviyo-Pause + Aufraeumen beim Schliessen ---------- */
  var geplant = false;
  function pruefe() {
    geplant = false;
    var offen = !!offenerDialog();
    document.documentElement.classList.toggle("bs-pplr-open", offen);
    if (!offen) versteckeHinweis();
    else uebersetzeMeldungen();
    kasten();
  }
  function plane() { if (!geplant) { geplant = true; setTimeout(pruefe, 80); } }
  /* kasten() sofort (vor dem naechsten Zeichnen, kein Aufblitzen des grossen Kastens), aber nur bei Aenderungen im Dialog */
  new MutationObserver(function (recs) { if (imDialog(recs)) kasten(); plane(); }).observe(document.documentElement, {
    subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["style", "class"]
  });
  document.addEventListener("click", function () { setTimeout(plane, 150); }, true);
  /* Drehen/Groesse aendern: Layout aendert sich ohne DOM-Aenderung -> Kasten und Knopf-Zeile neu ausrichten */
  window.addEventListener("resize", function () { kasten(); });
  /* 22.10.: Safari am iPhone - Tastatur und Adressleiste aendern oft nur den sichtbaren Bereich (visualViewport) */
  if (window.visualViewport) window.visualViewport.addEventListener("resize", function () { kasten(); });
  document.addEventListener("focusout", function () { setTimeout(kasten, 350); }, true);
  plane();

  /* ---------- Nr. 23: Escape schliesst den Dialog ---------- */
  function schliessKnopf(pop) {
    var icons = pop.querySelectorAll("a.pplr_close > i.fa-close");
    for (var i = 0; i < icons.length; i++) {
      var a = icons[i].parentElement;
      if (a && sichtbar(a)) return a;
    }
    return null;
  }
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" && e.key !== "Esc") return;
    var pop = offenerDialog();
    if (!pop || pop.classList.contains("pplr-crop-mode")) return;
    var t = e.target;
    if (t && t.closest && t.closest(".bs-flag-search")) return;
    var x = schliessKnopf(pop);
    if (!x) return;
    e.preventDefault();
    e.stopPropagation();
    try { x.click(); } catch (err) {}
  }, true);
})();
